





















































import Vue from 'vue';
import {
  Component, Mixins,
} from 'vue-property-decorator';
import { State } from 'vuex-class';
import { User } from '@/store/profile/types';
import { PimcoreEntityType } from '@/types/entity';
import GetList from '@/graphql/GetList.gql';
import EntityResolver from '@/classes/EntityResolver';
import UserMixin from '@/mixins/UserMixin';
import AdaptiveSizeClient from '@/mixins/AdaptiveSizeClient';

@Component({
  apollo: {
    entities: {
      query: GetList,
      update(data) {
        return data?.__schema?.queryType?.fields || [];
      },
    },
  },
})
export default class NavigationDrawer extends Mixins(Vue, UserMixin, AdaptiveSizeClient) {
  entities: Array<PimcoreEntityType> = [];

  @State('user', { namespace: 'profile' })
  stateUser: User | undefined;

  drawer = false

  get entitiesMap() {
    return EntityResolver.entitiesMap(this.entities);
  }

  get drawerProps() {
    if (this.smUp) {
      return {
        permanent: true,
        expandOnHover: true,
      };
    }
    return {
      absolute: true,
      temporary: true,
    };
  }
}

